var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Add_Media_Background_Mask_",
    "data-name": "Add Media (Background/Mask)",
    width: 48,
    height: 48,
    transform: "translate(-170 -24)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_Background_Mask_",
    "data-name": "Frame (Background/Mask)",
    width: 35.854,
    height: 33.13,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(170 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_de_m\\xE1scara_2",
    "data-name": "Grupo de m\\xE1scara 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    transform: "translate(-164 -17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_Background_Mask_2",
    "data-name": "Frame (Background/Mask)",
    width: 35.854,
    height: 33.13,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame-2",
    "data-name": "Frame",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1748",
    "data-name": "Group 1748",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.761,8.424a3.64,3.64,0,0,0-4.007.561l-2.04,1.821A3.6,3.6,0,0,0,21.93,7.919l1.776-1.481A3.641,3.641,0,1,0,19.045.844s-4.231,3.526-8.463,7.067C8.463,9.684,6.344,11.462,4.755,12.8,1.117,15.875.82,16.126.82,17.861a3.637,3.637,0,0,0,2.99,3.575C.232,24.3,0,24.55,0,26.274a3.641,3.641,0,0,0,6.176,2.613c.441-.374,2.114-1.714,4.374-3.511a5.519,5.519,0,0,0-.04.745,3.641,3.641,0,0,0,6.33,2.455C17.928,27.533,27.011,19.405,32.6,14.42a3.642,3.642,0,0,0-.84-6Z",
    transform: "translate(2.035)",
    fill: "#eaf0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.849,1.065A.273.273,0,0,1,.554.992L.07.456A.273.273,0,0,1,.475.089L.96.625a.274.274,0,0,1-.111.44Z",
    transform: "translate(28 1.137)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M.85,1.066A.273.273,0,0,1,.555.993L.071.457A.273.273,0,1,1,.476.09L.961.626a.273.273,0,0,1-.02.386h0A.273.273,0,0,1,.85,1.066Z",
    transform: "translate(29.304 2.578)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M.457.962a.273.273,0,1,1-.366-.4L.628.071a.273.273,0,1,1,.366.4h0Z",
    transform: "translate(29.349 1.227)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M.457.962a.273.273,0,1,1-.366-.4L.628.072a.273.273,0,1,1,.366.4h0Z",
    transform: "translate(27.902 2.536)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M.544.791A.2.2,0,0,1,.406.726L.051.333a.2.2,0,0,1,.3-.269L.7.457A.2.2,0,0,1,.688.74h0A.2.2,0,0,1,.544.791Z",
    transform: "translate(2.715 15.355)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M.545.792A.2.2,0,0,1,.407.727L.052.334a.2.2,0,1,1,.3-.269L.7.458A.2.2,0,0,1,.689.741h0A.2.2,0,0,1,.545.792Z",
    transform: "translate(3.67 16.411)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M.334.7a.2.2,0,0,1-.268-.3L.459.052a.2.2,0,0,1,.268.3h0Z",
    transform: "translate(3.703 15.422)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-9",
    "data-name": "Vector",
    d: "M.334.7a.2.2,0,0,1-.268-.3L.459.052a.2.2,0,1,1,.268.3h0Z",
    transform: "translate(2.644 16.38)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-10",
    "data-name": "Vector",
    d: "M.545.792A.2.2,0,0,1,.406.726L.051.334a.2.2,0,0,1,.3-.269L.7.458A.2.2,0,0,1,.545.792Z",
    transform: "translate(29.481 26.064)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-11",
    "data-name": "Vector",
    d: "M.544.791A.2.2,0,0,1,.406.726L.051.333a.2.2,0,0,1,.3-.269L.7.457A.2.2,0,0,1,.688.74h0A.2.2,0,0,1,.544.791Z",
    transform: "translate(30.437 27.121)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-12",
    "data-name": "Vector",
    d: "M.334.7a.2.2,0,0,1-.268-.3L.459.052a.2.2,0,0,1,.268.3Z",
    transform: "translate(30.469 26.131)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-13",
    "data-name": "Vector",
    d: "M.334.7a.2.2,0,0,1-.268-.3L.459.052a.2.2,0,1,1,.268.3h0Z",
    transform: "translate(29.41 27.089)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-14",
    "data-name": "Vector",
    d: "M5.191,3.067a.311.311,0,0,0,0-.607L4.5,2.318A1.738,1.738,0,0,1,3.156.948l-.14-.7a.3.3,0,0,0-.6,0l-.14.7A1.738,1.738,0,0,1,.933,2.318L.244,2.46a.311.311,0,0,0,0,.607l.689.142A1.738,1.738,0,0,1,2.28,4.578l.14.7a.3.3,0,0,0,.6,0l.14-.7A1.738,1.738,0,0,1,4.5,3.209h0Z",
    transform: "translate(2.718 26.988)",
    fill: "#ffd875"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-15",
    "data-name": "Vector",
    d: "M3.439,2.032a.206.206,0,0,0,0-.4l-.456-.094A1.152,1.152,0,0,1,2.091.628L2,.164a.2.2,0,0,0-.4,0L1.51.628a1.152,1.152,0,0,1-.892.907L.162,1.63a.206.206,0,0,0,0,.4l.456.094a1.152,1.152,0,0,1,.892.907L1.6,3.5a.2.2,0,0,0,.4,0l.093-.464a1.152,1.152,0,0,1,.892-.907h0Z",
    transform: "translate(0 3.568)",
    fill: "#ffd875"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-16",
    "data-name": "Vector",
    d: "M2.144,1.267a.128.128,0,0,0,0-.251L1.86.957A.718.718,0,0,1,1.3.392L1.246.1A.125.125,0,0,0,1,.1L.942.392A.718.718,0,0,1,.385.957L.1,1.016a.128.128,0,0,0,0,.251l.285.059a.718.718,0,0,1,.556.566L1,2.18a.125.125,0,0,0,.246,0L1.3,1.891a.718.718,0,0,1,.556-.566Z",
    transform: "translate(23.124 30.847)",
    fill: "#ffd875"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-17",
    "data-name": "Vector",
    d: "M7.358,3.184,6.78,1.231A1.636,1.636,0,0,0,5.25,0H1.613A1.708,1.708,0,0,0,0,1.792V15.039a2.544,2.544,0,0,0,2.4,2.668H18.074a1.989,1.989,0,0,0,1.874-2.086V6.6c0-1.375,0-3.418-1.824-3.418Z",
    transform: "translate(5.816 7.381)",
    fill: "#ffd875"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-18",
    "data-name": "Vector",
    d: "M1.415,11.091A1.519,1.519,0,0,1,.018,9.34L.536,1.751A1.79,1.79,0,0,1,2.172,0h13.72a1.519,1.519,0,0,1,1.4,1.751L16.772,9.34a1.79,1.79,0,0,1-1.636,1.751H1.415Z",
    transform: "translate(7.316 12.036)",
    fill: "#eaf0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-19",
    "data-name": "Vector",
    d: "M1.193,10.527A1.212,1.212,0,0,1,.087,8.865l1.779-7.2A2.176,2.176,0,0,1,3.792,0h13.72a1.212,1.212,0,0,1,1.106,1.662l-1.779,7.2a2.176,2.176,0,0,1-1.927,1.662H1.193Z",
    transform: "translate(8.477 13.109)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-20",
    "data-name": "Vector",
    d: "M22.54,2.64l-.144.38L19.782,9.66a3.431,3.431,0,0,1-3.073,1.72H1.315a1.354,1.354,0,0,1-1.2-1.06A2.094,2.094,0,0,1,.146,8.88L1.971,4.24a3.2,3.2,0,0,1,2.867-1.6H14.911L16.493.79A2.556,2.556,0,0,1,18.335,0h3.639a1.374,1.374,0,0,1,.359.04c.665.11,1.006.57.8,1.11Z",
    transform: "translate(6.947 14.085)",
    fill: "#68a7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-21",
    "data-name": "Vector",
    d: "M22.3.18,21.7,1.67l-.144.37L18.946,8.69a3.444,3.444,0,0,1-3.073,1.71H.479a.794.794,0,0,1-.368-.08A2.094,2.094,0,0,1,.146,8.88L1.971,4.24a3.2,3.2,0,0,1,2.867-1.6H14.911L16.493.79A2.556,2.556,0,0,1,18.335,0h3.639a1.374,1.374,0,0,1,.359.04h0A.4.4,0,0,1,22.3.18Z",
    transform: "translate(6.947 14.085)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-22",
    "data-name": "Vector",
    d: "M5.445,3.924A2.827,2.827,0,0,1,2.83,5.67H2.8A2.833,2.833,0,0,1,2.1.1,2.524,2.524,0,0,1,2.83,0,2.84,2.84,0,0,1,5.445,3.924Z",
    transform: "translate(9.717 21.395)",
    fill: "#eaf0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-23",
    "data-name": "Vector",
    d: "M4.314,4.562A2.823,2.823,0,0,1,2.8,5.57,2.833,2.833,0,0,1,2.1,0,2.836,2.836,0,0,1,4.9,2.84h0A2.823,2.823,0,0,1,4.314,4.562Z",
    transform: "translate(9.717 21.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-24",
    "data-name": "Vector",
    d: "M2.093,1.273V.4a.4.4,0,0,0-.4-.4H1.652a.4.4,0,0,0-.4.4v.873H.4a.4.4,0,0,0-.4.4H0a.4.4,0,0,0,.4.4h.853v.873a.4.4,0,0,0,.4.4h.041a.4.4,0,0,0,.4-.4V2.072h.853a.4.4,0,1,0,0-.8H2.093Z",
    transform: "translate(10.874 22.558)",
    fill: "#ffd875"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-25",
    "data-name": "Vector",
    d: "M5.579,0A1.355,1.355,0,0,1,6.934,1.355V3.768A1.355,1.355,0,0,1,5.579,5.123H1.355A1.355,1.355,0,0,1,0,3.768V1.355A1.355,1.355,0,0,1,1.355,0Z",
    transform: "translate(24.562 3.819) rotate(24.14)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-26",
    "data-name": "Vector",
    d: "M.034,1.351a.394.394,0,0,0,.382.555l1.292-.073A.394.394,0,0,0,2,1.2L1.21.156A.394.394,0,0,0,.536.233Z",
    transform: "translate(25.562 6.404)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-27",
    "data-name": "Vector",
    d: "M5.988,0a.651.651,0,0,1,.651.651V5.085a.651.651,0,0,1-.651.651H.651A.651.651,0,0,1,0,5.085V.651A.651.651,0,0,1,.651,0Z",
    transform: "translate(12.383 3.806)",
    fill: "#7cb2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-28",
    "data-name": "Vector",
    d: "M5.207,0a.566.566,0,0,1,.566.566V4.422a.566.566,0,0,1-.566.566H.566A.566.566,0,0,1,0,4.422V.566A.566.566,0,0,1,.566,0Z",
    transform: "translate(12.815 4.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-29",
    "data-name": "Vector",
    d: "M3.029,1.653,0,1.51,2.221,0Z",
    transform: "translate(15.162 6.534)",
    fill: "#d3dce2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-30",
    "data-name": "Vector",
    d: "M2.152,0l.872.726.873.725L0,1.37Z",
    transform: "translate(13.214 6.674)",
    fill: "#eaf0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-31",
    "data-name": "Vector",
    d: "M.428.855A.428.428,0,1,1,.855.428.428.428,0,0,1,.428.855Z",
    transform: "translate(14.223 5.252)",
    fill: "#ffd875"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMedia);
export default __webpack_public_path__ + "static/media/add-media.915ea65dcd1c1bf01e67b876d8af9eb1.svg";
export { ForwardRef as ReactComponent };